import { beads, Bead } from '../beads.js';
import { settings } from '../settings.js';
import { mirror } from '../tools/mirror.js';
import { star } from './star.js';

export const squareConfig = {
    name: 'square',
    displayName: 'Warped Square',
    colDist: () => 38,
    rowDist: () => 32,
    offset: () => -19,
    offsetPattern: [0, 1],
    apply: () => {
        star.morphToSquare();
    },
    create: () => {
        let n = settings.rows;
        let beadsNeeded = (n * (n + 1)) * 2;
        for (let i = 0; i < beadsNeeded; i++) {
            let j = Math.floor(i / 10);
            beads.arr.push(new Bead(j, i));
        }
    },
    commutes: false,
    canSelectCommute: false,
    plastic: false,
    canSelectDirection: false,
    canSelectStartingBead: false,
    canSelectPanelWidth: false,
    canExportSmallDiagrams: false,
    beadFromPoint: true,
    noCustomBeadSize: true,
    noColumns: true,
    rowLimit: 30,
    noChangePattern: true,
    noDrag: true,
    noGuides: true,
    getDimensions: (myRows, myColumns, diameter, beadLength) => {
        return {
            width: myRows * beadLength / 4,
            height: myRows * beadLength / 4
        };
    },
    getExportImageDimensions: rows => {
        const max = Math.max(settings.rows, 4);
        return {
            width: 2000 * (max / 20),
            height: 2000 * (max / 20)
        }
    },
    getBeadingModeStartingPosition: ({bead}) => [1, null],
    disabledTools: ['Row Shift', 'Paint', 'Star'],
    getRowsAndColumns: ({rows, columns, size}) => {
        rows = size;
        columns = 0; // not used
        return [rows, columns];
    },
    useSingleRenderTexture: true,
    manualFindBead: true,
    alterProject: star.alterProject,
    specialMirror: true,
    startMirror: () => {
        beads.mirror.forEach(mirror => {
            mirror.setX(star.mirrorPoint.x);
            mirror.setY(star.mirrorPoint.y);
        });
        if (!beads.mirror.active || (beads.mirror.orientation === 'none')) {
            beads.mirror.orientation = 'vertical';
            beads.mirror[0].setAlpha(1);
            beads.mirror[1].setAlpha(1);
            beads.mirror.active = true;
        }
    },
    findMirrorBead: mirror.findSquareMirrorBead,
    getRTLocation() {
        const x = 350 - ((settings.rows - 7) * 15);
        const y = 350 - ((settings.rows - 7) * 15);
        return [x, y];
    },
    getStripsKey: 'getSquareStrips',
    getWordChartKey: 'getSquareWordChart',
    noDiagrams: true,
    getImportedBead: ({bead}) => {
        if (!bead.star) return;
        return beads.tempArray.find(element =>
            element.star.beadNumber === bead.star.beadNumber &&
            element.star.row === bead.star.row &&
            element.star.side === bead.star.side
        );
    },
    doBeadingKey: 'square',
    advanceBeadingKey: 'advanceSquare',
    rotateMirror: mirror.rotateSquareMirror,
    arrangeGrid: false
};